import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import "./WayfairPurchaseOrderModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../../models/ISupplierModel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IWayfairPullPurchaseOrdersDTO from "../../../../models/DTO/IWayfairPullPurchaseOrdersDTO";
import IWayfairOnPullPurchaseOrdersDTO from "../../../../models/DTO/IWayfairOnPullPurchaseOrdersDTO";
import INotification from "../../../../models/INotification";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import Moment from "moment";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: (refreshData?: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const WayfairPurchaseOrderModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [wayfairBtnActive, setWayfairBtnActive] = useState(false);
    const [selectedFromDate, setSelectedFromDate] = useState(Moment());
    const [wayfairPullData, setWayfairPullData] = useState<IWayfairOnPullPurchaseOrdersDTO>();
    const [limit, setLimit] = useState(10);

    const closeModal = () => {
        props.closeModalFn(true);
    };

    const wayfairPullPurchaseOrders = () => {
        let isoFromDate = selectedFromDate.startOf("day").toISOString(false);

        isoFromDate = isoFromDate.replace("T08", "T00");

        const payload: IWayfairPullPurchaseOrdersDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            fromDate: isoFromDate,
            limit,
        };

        props.socket.emit(EndpointsEnum.WayfairPullPurchaseOrders, payload);

        setWayfairBtnActive(true);
    };

    const onWayfairPullPurchaseOrders = (data: IWayfairOnPullPurchaseOrdersDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_wayfair_purchase_orders",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);

        setWayfairBtnActive(false);
        setWayfairPullData(data);
    };

    useEffect(() => {
        props.socket.on(EndpointsEnum.WayfairOnPullPurchaseOrders, onWayfairPullPurchaseOrders);

        return () => {
            props.socket.removeListener(EndpointsEnum.WayfairOnPullPurchaseOrders, onWayfairPullPurchaseOrders);
        };
    }, []);

    const handleFromDate = (date: Moment.Moment) => {
        setSelectedFromDate(date);
    };

    const handlePullLimit = (e: ChangeEvent<any>) => {
        const value = Number(e.target.value);

        setLimit(value);
    };

    const limitOptions = [
        { value: 10, title: 10 },
        { value: 25, title: 25 },
        { value: 50, title: 50 },
        { value: 100, title: 100 },
        { value: 250, title: 250 },
    ];

    return (
        <div className={"WayfairPurchaseOrderModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"wayfair_pull_purchase_orders"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwLabel title={"from_date"} />
                    <div>
                        <OwDateInput selectedDate={selectedFromDate} fn={handleFromDate} />
                    </div>
                </div>

                <div className={"mt-3"}>
                    <OwLabel title={"pull_limit"} />
                    <div>
                        <OwSelectOption
                            fn={handlePullLimit}
                            name={"limit"}
                            selectedOption={limit}
                            hasSelectedOptionProp={false}
                            options={limitOptions}
                            valueProp={"value"}
                            titleProp={"title"}
                        />
                    </div>
                </div>

                <div className={"mt-3"}>
                    <OwButton title={"start"} fn={wayfairPullPurchaseOrders} active={wayfairBtnActive} disableOnActive={true} />
                </div>
            </div>

            {wayfairPullData ? (
                <div className={"mt-5"}>
                    <div>
                        <OwLabel title={"total_pulled"} postText={":"} /> {wayfairPullData.totalPulled}
                    </div>
                    <div>
                        <OwLabel title={"total_created"} postText={":"} /> {wayfairPullData.totalCreated}
                    </div>
                    <div>
                        <OwLabel title={"total_existing"} postText={":"} /> {wayfairPullData.totalExisting}
                    </div>
                    <div>
                        <OwLabel title={"total_errored"} postText={":"} /> {wayfairPullData.totalErrored}
                    </div>
                    <div>
                        <pre>
                            {wayfairPullData.errorDetails.map((errorDetail) => {
                                return (
                                    <>
                                        {errorDetail.poNumber} - {errorDetail.poNumber}
                                    </>
                                );
                            })}
                        </pre>
                    </div>
                </div>
            ) : null}
        </div>
    );
};
